import React from 'react';
import { PagePath, RowHeaderTable, TableVehicles } from '../../components';
// import { Container } from './styles';

const Vehicles: React.FC = () => {
  return (
    <div>
      <PagePath
        goBack={{
          title: 'Dashboard',
          goBackPath: '/home/dashboard-admin',
        }}
      />
      <div className="container-body no-padding">
        <RowHeaderTable
          name="Veículos"
          navigationPath="/home/vehicles/create"
        />
        <TableVehicles />
      </div>
    </div>
  );
};

export default Vehicles;
